/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
  computed,
  type ReadonlySignal,
  type Signal,
  signal,
} from '@preact/signals-react'

import { reverseStringValue } from '@/helpers'
import { type TOfflineState } from '@/interfaces'

import { AuthState } from '../auth'

const isOnline: Signal<boolean> = signal(navigator.onLine ?? false)

const existNetworkConnection: Signal<boolean> = signal(navigator.onLine)

const isSynchronizing: Signal<boolean> = signal(false)

const storeApplications: Signal<string[]> = signal([])

const syncAppsIds: Signal<string[]> = signal([])

const DBName: ReadonlySignal<string | null> = computed(() => {
  let userDBName = AuthState.currentUser.value?.id ?? null

  if (userDBName) {
    userDBName = reverseStringValue(userDBName)
  }

  return userDBName
})

export const OfflineState: TOfflineState = {
  DBName,
  existNetworkConnection,
  isOnline,
  isSynchronizing,
  storeApplications,
  syncAppsIds,
}
